import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { filter, Subject, take, takeUntil } from 'rxjs';
import { DocumentTypeModalComponent } from 'src/app/clinic-studies/edit-clinical-study-profile/components/document-type-modal/document-type-modal.component';
import { StudyFile } from 'src/app/models/Study/study-file.model';
import { Status } from 'src/app/models/status/status.model';
import { AuthService } from 'src/app/services/auth.service';
import { StudiesFacade } from 'src/app/shared-new/store/studies/studies.facade';
import { ViewerService } from '../../../../services/viewer.service';
import { StudyFileNotificationModalComponent } from '../study-file-notification-modal/study-file-notification-modal.component';
import { EventsEmitter } from '../../../../shared/event-emitter/EventEmitter';
import { NotificationsService } from '../../../../services/notifications.service';
import { StudyStatus } from '../../../../shared-new/enums/study-status.enum';
import { BaseUnsubscribeComponent } from '../../../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { SelectionModel } from '@angular/cdk/collections';

@Component({
  selector: 'study-docs-list-table',
  templateUrl: './study-docs-list-table.component.html',
  styleUrls: ['./study-docs-list-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StudyDocsListTableComponent extends BaseUnsubscribeComponent implements OnInit {
 
  dataSource: any[] = [];
  dataSource2: any[] = [];
  @Input() openButtonText: string = 'Open';
  @Input() headingText: string;
  @Input() isReadOnly: boolean = false;
  @Input() statuses: Status[] = [];
  @Input() required: boolean = false;
  @Input() isInReview: boolean = false;
  @Input() isInUpload: boolean = false;
  @Input() studyFiles: StudyFile[] = [];
  @Output() openButtonClicked = new EventEmitter();
  @Output() downloadButtonClicked = new EventEmitter();
  @Output() deleteFileClicked = new EventEmitter();
  deniedStudyFileIds: any[] = [];
  public isUserSaleEditor: boolean = true;
  activeSaleHorseStudy$ = this.studyFacade.activeSaleHorseStudy$;
  public loggedInMemberId: number = null;
  isLoader: boolean = false;
  studyId: number = 0;
  saleId: number = 0;
  horseId: number = 0;
  studyStatusError$ = this.studyFacade.studyStatusError$;
  studyStatusSuccess$ = this.studyFacade.studyStatusSuccess$;
  StudyStatus = StudyStatus;
  selection = new SelectionModel<any>(true, []); // Manage selected rows
  @Output() updateStatus = new EventEmitter();
  @Input() selectAll = false;
  @Output() selectionChanged = new EventEmitter<any>();
  isSalesCompany: boolean = false;
  public lotOrHipText: string;
  displayedColumns: string[] = [
    'fileName',
    'videoType',
    'details',
    'uploadedby',
    'uploadeddate',
    'status',
    'comment',
    'action',
  ];
  unAssignedCount: number = 0;
  constructor(
    private studyFacade: StudiesFacade,
    private modalService: NgbModal,
    private authService: AuthService,
    private viewerService: ViewerService,
    private readonly eventEmitter: EventsEmitter,
    private changeDetectorRefs: ChangeDetectorRef,
    private readonly notificationService: NotificationsService
  ) {
    super();
    this.isSalesCompany = this.authService.IsSalesCompany();
  }

  ngOnInit(): void {
    if (!this.isInReview) {
      this.displayedColumns = this.displayedColumns.filter(x => x != 'comment');
    }
    this.authService
      .getUserData()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        const user = JSON.parse(data);
        this.loggedInMemberId = user.memberId;
      });

    this.attachEvents();
  }
  arraysHaveDifferences(arr1: any[], arr2: any[]): boolean {
    if (!Array.isArray(arr1) || !Array.isArray(arr2)) {
      return true;
    }

    if (arr1.length !== arr2.length) {
      return true;
    }

    for (let i = 0; i < arr1.length; i++) {
      const obj1 = arr1[i];
      const obj2 = arr2[i];

      const keys1 = Object.keys(obj1);
      const keys2 = Object.keys(obj2);

      if (keys1.length !== keys2.length) {
        return true;
      }

      for (const key of keys1) {
        if (obj1[key] !== obj2[key]) {
          return true;
        }
      }
    }

    return false;
  }
  ngOnChanges(changes: SimpleChanges): void {
    const studyFiles = changes['studyFiles'];
    if ((studyFiles && this.arraysHaveDifferences(studyFiles.currentValue, studyFiles.previousValue)) || studyFiles?.firstChange) {
      this.dataSource = this.studyFiles.map((studyFile) => {
        const studyFileCopy = JSON.parse(JSON.stringify(studyFile)); // Deep copy
        studyFileCopy.originalStudyStatusId = studyFile.studyStatusId;
        return studyFileCopy;
      });
      this.dataSource2 = [...this.dataSource];
      this.unAssignedCount = this.studyFiles.filter(x => !x.documentTypeName).length;
    }
    this.onChanges();
  }
  private attachEvents() {
    this.activeSaleHorseStudy$
      .pipe(
        filter((s) => !!s),
        take(1)
      )
      .subscribe((study) => {
        if (study != null) {
          this.saleId = study.saleId;
          this.horseId = study.horseId;
        }
      });

    this.authService
      .getMemberLotOrHipText()
      .pipe(take(1))
      .subscribe((text) => {
        this.lotOrHipText = text;
      });
  }
  public isStudyFileEditable(file: StudyFile) {
    if (!this.isInReview) {
      let isEditable: boolean =
        this.isReadOnly &&
        (file.studyStatusId === StudyStatus.Draft || file.studyStatusId === StudyStatus.Submitted);
      isEditable = isEditable && file.memberId === this.loggedInMemberId;
      return isEditable;
    } else {
      return false;
    }
  }

  viewPdf(studyFile: StudyFile) {
    this.activeSaleHorseStudy$.pipe(take(1)).subscribe((study) => {
      if (this.isInReview || this.isInUpload) {
        this.viewerService.openPdf(study, studyFile,null,false,null,false);
      } else {
        this.viewerService.openPdf(study, studyFile);
      }
    
    });
  }
  emitDeleteButtonClicked(studyFileId: number): void {
    this.deleteFileClicked.emit(studyFileId);
  }
  onChangeStatus(e: any, studyFile: any) {
    studyFile.statusMessage = '';
    this.updatePdfFileStatus({
      studyFileIds: [studyFile.studyFileId],
      statusId: studyFile.studyStatusId,
      studyFile: studyFile,
    });
  }
  openDenyModal(studyFile: any, statusId: number, studyFileIds: number[]): void {
    this.activeSaleHorseStudy$.pipe(take(1)).subscribe((study) => {
      this.notificationService.getStudySubmissionRecipients(study.saleId, study.horseId, statusId, studyFileIds).pipe(takeUntil(this.unsubscribe$)).subscribe((response) => {
        const modalRef = this.modalService.open(StudyFileNotificationModalComponent, {
          size: 'lg',
          centered: true,
          keyboard: false,
          backdrop: 'static',
        });
        const { recipients, ...rest } = response;

        // Only the submitting vet's recipients: "viewed by" vets are never told about an approval or a
        // denial (they get the separate New Data Submitted notification).
        const submittingRecipients = (recipients || []).filter((r: any) => !r.isViewingOnly);

        // Create independent objects
        const notificationData = {
          ...rest,
          recipients: submittingRecipients
        };
        modalRef.componentInstance.data = {
          statusId: statusId,
          notificationData: notificationData,
          lotOrHipText: this.lotOrHipText,
        };
        modalRef.result.then(
          (result) => {
            const reason = result.reason;
            const notificationData = result.notificationData;
            this.updateStudyFileStatuses(this.deniedStudyFileIds, statusId, reason, notificationData);
            this.changeDetectorRefs.detectChanges();
          },
          (reason) => {
            studyFile.studyStatusId = studyFile.originalStudyStatusId;
            this.changeDetectorRefs.detectChanges();
          }
        );
      });
    })
  }

 

  onChanges() {
    // When parent toggles select all, update this table's selection
    if (this.selectAll) {
      this.selection.select(
        ...this.dataSource2.filter(
          element => element.originalStudyStatusId !== StudyStatus.Approved && element.originalStudyStatusId !== StudyStatus.Denied
        )
      );
    } else {
      this.selection.clear();
    }
    this.emitSelectionChanged();
  }

  toggleRow(row: any) {
    this.selection.toggle(row);
    this.emitSelectionChanged();
  }

  toggleAllRows() {
    if (this.selection.hasValue()) {
      this.selection.clear();
    } else {
      this.selection.select(
        ...this.dataSource2.filter(
          element => element.originalStudyStatusId !== StudyStatus.Approved && element.originalStudyStatusId !== StudyStatus.Denied
        )
      );
    }
    this.emitSelectionChanged();
  }

  isAllSelected() {
    if (this.isAllDisabled()) {
      return false;
    }
    const selectableItems = this.dataSource2.filter(
      element => element.originalStudyStatusId !== StudyStatus.Approved && element.originalStudyStatusId !== StudyStatus.Denied
    );
    return this.selection.selected.length === selectableItems.length;
  }
  isAllDisabled() {
    const selectableItems = this.dataSource2.filter(
      element => element.originalStudyStatusId == StudyStatus.Approved || element.originalStudyStatusId == StudyStatus.Denied
    );
    return this.dataSource2.length === selectableItems.length;
  }

  emitSelectionChanged() {
    const result = {
      selectedHorses: this.selection.selected,
      type: this.headingText,
      isAllSelected: this.isAllSelected()
    }
    this.selectionChanged.emit(result);
  }

  emitDownloadButtonClicked(studyFile: StudyFile) : void {
    this.downloadButtonClicked.emit(studyFile);
  }

  updateStudyFileStatuses(
    studyFileIds: number[],
    statusId: number,
    reason?: string,
    notificationData?: any
  ): void {
    this.isLoader = true;
    this.studyFacade.updateStudyFileStatuses(studyFileIds, statusId, reason, notificationData);
  }
  updatePdfFileStatus(data: {
    studyFileIds: number[];
    statusId: number;
    studyFile: any;
  }): void {
    if (data.statusId == StudyStatus.Denied || data.statusId == StudyStatus.Approved) {
      this.deniedStudyFileIds = data.studyFileIds;
      this.openDenyModal(data.studyFile, data.statusId, data.studyFileIds);
    } else {
      this.deniedStudyFileIds = [];
      this.updateStudyFileStatuses(data.studyFileIds, data.statusId);
    }
  }
  openDocTypePopup(studyFile: StudyFile, isReport: boolean): void {
    const modalRef = this.modalService.open(DocumentTypeModalComponent, {
      ariaLabelledBy: 'templatePopup',
      centered: true,
      size: 'lg',
      keyboard: false,
      backdrop: 'static',
    });

    modalRef.componentInstance.data = {
      studyFileId: studyFile.studyFileId,
      docTypeId: studyFile.documentTypeId,
      isReport: isReport
    };
    modalRef.result.then(
      (result) => {
        const data = JSON.parse(result);
        this.studyFacade.updateStudyDocType(
          data.studyFileId,
          data.docTypeId,
          data.docTypeName,
          isReport
        );
      },
      (reason) => { }
    );
  }
}
